// ©2024 Austin App House. All rights reserved.
import React from 'react';
import {connect} from 'react-redux';

import { toggleModal } from '../../storage/actions/modalsActions';
import Loader from '../dashboard/common/Loader';
import { submitApply, cancelApplication } from '../../storage/actions/workOrdersActions';
import { localCurrencySettings } from '../../utils/constans';
import FormApplyModal from './FormApplyModal';

const ApplyModal = ({
  currentWorkOrder, modalState, toggleModal, submitApply, cancelApplication,
}) => (
  // eslint-disable-next-line no-nested-ternary
  modalState.isOpen
    ? currentWorkOrder
      ? (
        <div className={`dashboard-modal ${modalState.isOpen ? 'dashboard-modal--open dashboard-modal--apply' : ''}`}>
          <div className="dashboard-modal-panel">
            <div className="dashboard-modal-header">
              <h4 className="dashboard-modal-title">Apply For Work</h4>
              <button
                className="dashboard-modal-close"
                onClick={() => toggleModal(false, 'applyModal')}
              />
            </div>
            <div className="dashboard-modal-body">
              <div style={{ padding: '10px' }}>
                  <span
                    className="font12"
                    style={{
                      fontWeight: 'bold',
                      marginRight: '10px',
                    }}
                  >
                    Company WO ID:
                  </span>
                  <span className="font12">{currentWorkOrder.siteId}</span>
                </div>
              <div style={{ padding: '10px' }}>
                  <span
                    className="font12"
                    style={{
                      fontWeight: 'bold',
                      marginRight: '10px',
                    }}
                  >
                    Project Name:
                  </span>
                  <span> {currentWorkOrder.title}</span>
                </div>
              <div style={{ padding: '10px' }}>
                  <span
                    className="font12"
                    style={{
                      fontWeight: 'bold',
                      marginRight: '10px',
                    }}
                  >
                    Start Date:
                  </span>
                  <span className="font12">
                    {
                        new Date(currentWorkOrder.startDate)
                          .toLocaleDateString('en-US', { timeZone: 'UTC' }) === 'Invalid Date'
                          ? ''
                          : new Date(currentWorkOrder.startDate)
                            .toLocaleDateString('en-US', { timeZone: 'UTC' })
                      }
                  </span>
                </div>
              <div style={{ padding: '10px' }}>
                  <span
                    className="font12"
                    style={{
                      fontWeight: 'bold',
                      marginRight: '10px',
                    }}
                  >
                    End Date:
                  </span>
                  <span className="font12">
                    {
                        new Date(currentWorkOrder.endDate)
                          .toLocaleDateString('en-US', { timeZone: 'UTC' }) === 'Invalid Date'
                          ? ''
                          : new Date(currentWorkOrder.endDate)
                            .toLocaleDateString('en-US', { timeZone: 'UTC' })
                    }
                  </span>
                </div>
              <div style={{ padding: '10px' }}>
                  <span
                    className="font12"
                    style={{
                      fontWeight: 'bold',
                      marginRight: '10px',
                    }}
                  >
                    Start Time:
                  </span>
                  <span className="font12">{currentWorkOrder.startTime}</span>
                </div>
              <div style={{ padding: '10px' }}>
                  <span
                    className="font12"
                    style={{
                      fontWeight: 'bold',
                      marginRight: '10px',
                    }}
                  >
                    End Time:
                  </span>
                  <span className="font12">{currentWorkOrder.endTime}</span>
                </div>
              <div style={{ padding: '10px' }}>
                  <span
                    className="font12"
                    style={{
                      fontWeight: 'bold',
                      marginRight: '10px',
                    }}
                  >
                    Distance:
                  </span>
                  <span
                    className="font12"
                  >
                    {
                        (currentWorkOrder.distance || (currentWorkOrder.distance === 0))
                          ? `${currentWorkOrder.distance.toFixed(2)} Miles`
                          : ''
                      }
                  </span>
                </div>
              <div style={{ padding: '10px' }}>
                  <span
                    className="font12"
                    style={{
                      fontWeight: 'bold',
                      marginRight: '10px',
                    }}
                  >
                    Work Description:
                  </span>
                  <div
                    dangerouslySetInnerHTML={{ __html: currentWorkOrder.description }}
                    style={{ fontSize: 12 }}
                  />
                </div>
              <div style={{ padding: '10px' }}>
                  <span
                    className="font12"
                    style={{
                      fontWeight: 'bold',
                      marginRight: '10px',
                    }}
                  >
                    Tools Required:
                  </span>
                  <div
                    className="modal_description"
                    dangerouslySetInnerHTML={{ __html: currentWorkOrder.customTools }}
                  />
                </div>
              <div style={{ padding: '10px' }}>
                  <span
                    className="font12"
                    style={{
                      fontWeight: 'bold',
                      marginRight: '10px',
                    }}
                  >
                    Work Type:
                  </span>
                  <div>
                    {
                        (
                          currentWorkOrder.workTypes !== undefined
                          && currentWorkOrder.workTypes instanceof Array
                        )
                        && currentWorkOrder.workTypes.map(toolsType => (
                          <span key={toolsType.title}>{toolsType.title} </span>
                        ))
                      }
                  </div>
                </div>
              <div style={{ padding: '10px' }}>
                  <span
                    className="font12"
                    style={{
                      fontWeight: 'bold',
                      marginRight: '10px',
                    }}
                  >
                    Base Pay:
                  </span>
                  <span className="font12">
                    {
                        `${
                          currentWorkOrder.amount.toLocaleString('en-US', localCurrencySettings)
                        } Per ${currentWorkOrder.basicType} `
                      }
                    {
                        currentWorkOrder.basicType !== 'Site'
                          ? `for the first ${currentWorkOrder.quantity} ${currentWorkOrder.basicType
                            .toLocaleLowerCase()}${currentWorkOrder.quantity > 1 ? 's' : ''}`
                          : ''
                      }
                    .
                  </span>
                  {
                      currentWorkOrder.payBaseRateAsMinimum
                        ? (
                          <span
                            style={{
                              marginLeft: '1.5rem',
                              marginBottom: '0.5rem',
                              color: 'red',
                              padding: '0.3rem',
                              border: '2px solid red',
                            }}
                          >
                            MIN
                          </span>
                        )
                        : <></>
                    }
              </div>
                {
                    (currentWorkOrder.variableAmount)
                    && (currentWorkOrder.variableAmount !== 0)
                    && (currentWorkOrder.variableAmount !== '0')
                      ? (
                        <div className="field_name">
                          <span className="block_label">Variable Pay: </span>
                          <span className="font12">
                            {
                              `${
                                currentWorkOrder.variableAmount.toLocaleString('en-US', localCurrencySettings)
                              } Per ${currentWorkOrder.variableType}`
                            }
                            {
                              currentWorkOrder.variableType !== 'Site'
                                ? ` AFTER the first ${currentWorkOrder.variablePayAfter} ${currentWorkOrder.variableType
                                  .toLocaleLowerCase()}${currentWorkOrder.variablePayAfter > 1 ? 's' : ''}`
                                : ''
                            }
                            .
                          </span>
                        </div>
                      )
                      : <></>
                  }
              <div style={{ padding: '10px' }}>
                  <span
                    className="font12"
                    style={{
                      fontWeight: 'bold',
                      marginRight: '10px',
                    }}
                  >
                    Total Potential Pay Amount:
                  </span>
                  <span
                    className="font12"
                  >
                    {
                        (currentWorkOrder.holdFounds || 0)
                          .toLocaleString('en-US', localCurrencySettings)
                      }
                  </span>
              </div>
                {
                    currentWorkOrder.payOutsideOfApp
                      && (
                        <div
                          style={{
                            padding: '10px',
                            color: '#009933',
                          }}
                        >
                          <span
                            className="font14"
                            style={{
                              fontWeight: 'bold',
                              marginRight: '10px',
                            }}
                          >
                            Paid Outside of Wurqly Directly by Client!
                          </span>
                        </div>
                      )
                  }
              <FormApplyModal
                currentWorkOrder={currentWorkOrder}
                modalState={modalState}
                toggleModal={toggleModal}
                submitApply={submitApply}
              />
            {
              (currentWorkOrder.applied === true)
              && (
                <div style={{ textAlign: 'end', marginTop: '10px' }}>
                  <button
                    color="danger"
                    className="dashboard-btn dashboard-btn--secondary"
                    onClick={() => cancelApplication(currentWorkOrder._id)}
                  >
                    Cancel Application
                  </button>
                </div>
              )
            }
            </div>
          </div>
        </div>
      )
      : <Loader />
    : null
);

const mapStateToProps = state => ({
  currentWorkOrder: state.workOrder.currentWorkOrder,
  user: state.auth.user,
  modalState: state.modalState.applyModal,
});

export default connect(mapStateToProps, {
  toggleModal,
  submitApply,
  cancelApplication,
})(ApplyModal);
